export interface ILoginRequest {
	email: string;
	password: string;
	returnUrl: string;
	rememberMe: boolean;
}

export interface ILoginResponse {
	returnUrl?: string;
	isOk?: boolean;
	error?: string;
	errorDetail?: string;
}

export interface ILoggedOutModel {
	postLogoutRedirectUri: string;
	clientName: string;
	signOutIframeUrl: string;
	automaticRedirectAfterSignOut: boolean;
	logoutId: string;
	triggerExternalSignout: boolean;
	externalAuthenticationScheme: string;
}

export interface IRegisterRequest {
	email: string;
	password: string;
	returnUrl: string;
	codFisc: string;
	name: string;
	surname: string;
	born: Date;
	indirizzo: string;
	citta: string;
	cap: number;
	associationId: string;
	provincia: string;
	nazione: string;
	sex: ESex;
	professione: string;
}

export interface IRegisterResponse {
	returnUrl?: string;
	userName?: string;
	error?: string;
	errorDetail?: string;
}

/** @deprecated Usare IRegisterRequest */
export type IRegisterModel = IRegisterRequest;

export interface IRegisterCompnyModel {
	email: string;
	password: string;
	returnUrl: string;
	codFisc: string;
	name: string;
	surname: string;
	born: Date;
	nameCompany: string;
	indirizzo: string;
	citta: string;
	cap: number;
	provincia: string;
	nazione: string;
	partitaIva?: string;
	codFiscCompany: string;
	type: number;
	userRef?: string;
	confirm: boolean
	sex: ESex
}

export interface IType {
	value: number;
	label: string;
}

export interface IConfirmEmailRequest {
	userId: string;
	code: string;
	returnUrl: string;
}

export interface IAcceptRejectRequest {
	userId: string;
	token: string;
	action: string;
}

export interface IRequestResetPassword {
	email: string,
	returnUrl: string
}

export interface IRequestUpdatePassword {
	userId:string;
	code:string;
	password:string;
}

export enum ESex {
	Male,
	Female
}